import PermissionDto, {
  AbilityResponse,
  transformBusinessUserAbilityResponseToDto,
} from '@/dto/Auth/PermissionDto'
import RoleDto, { transformBusinessUserRoleResponseToDto } from '@/dto/Auth/RoleDto'
import { LeadStatusColor } from '@/shared'
import { FileUploadItemResponseDTO } from '@/dto/common/files'

export interface UserQueryParams {
  search?: string
  page?: number
}

// General user response
export type UserResponseDto = {
  id: string
  email: string
  phone: string | null
  first_name: string
  last_name: string
  color: LeadStatusColor
  photo: FileUploadItemResponseDTO | null
  created_at: string
  updated_at: string
}

// Currently authenticated user response
export type UserItemResponse = {
  id: string
  email: string
  phone: string | null
  first_name: string
  last_name: string
  color: LeadStatusColor
  photo: FileUploadItemResponseDTO | null
  created_at: string
  updated_at: string
  is_admin: boolean
  abilities: AbilityResponse[]
  roles: RoleDto[]
  intercom_hash?: string
}

export default class UserDto {
  public id: string
  public email: string | null = null
  public phone: string | null = null
  public first_name: string = ''
  public last_name: string = ''
  public color: LeadStatusColor | null = null
  public photo: FileUploadItemResponseDTO | null = null
  public createdAt: Date | null = null
  public updatedAt: Date | null = null
  public isAdmin = false
  public abilities: PermissionDto[] = []
  public roles: RoleDto[] = []
  public intercomHash: string | undefined = undefined

  constructor(id: string) {
    this.id = id
  }
}

export function transformUserItemResponseToDto(userItem: UserItemResponse): UserDto {
  const userDto = new UserDto(userItem.id)
  userDto.email = userItem.email
  userDto.phone = userItem.phone
  userDto.first_name = userItem.first_name
  userDto.last_name = userItem.last_name
  userDto.color = userItem.color
  userDto.photo = userItem.photo
  userDto.createdAt = null !== userItem.created_at ? new Date(userItem.created_at) : null
  userDto.updatedAt = null !== userItem.updated_at ? new Date(userItem.updated_at) : null
  userDto.isAdmin = userItem.is_admin
  userDto.abilities = userItem.abilities.map(transformBusinessUserAbilityResponseToDto)
  userDto.roles = userItem.roles.map(transformBusinessUserRoleResponseToDto)
  userDto.intercomHash = userItem.intercom_hash

  return userDto
}
